import React, { useState, useEffect, useRef } from 'react'
import Grid from '@mui/joy/Grid'
import {
  useGetStoreDataQuery,
  useUploadStampImageMutation,
} from '../services/branding'
import ImageStamp from './ImageStamp'

type StampProps = {
  gridKey: number
  index: number
}

function Stamp(props: StampProps) {
  const elementRef = useRef<HTMLDivElement | null>(null)
  const [stampImageUrl, setStampImageUrl] = useState<string | null>(null)
  const [textColor, setTextColor] = useState('#000000')
  const [fontFamily, setFontFamily] = useState('')

  const [uploadStampImage] = useUploadStampImageMutation({
    fixedCacheKey: 'shared-delete-reward',
  })
  const { data: storeData } = useGetStoreDataQuery()

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null
    if (file) {
      const formData = new FormData()
      formData.append('file', file)
      uploadStampImage(formData)
    }
  }

  useEffect(() => {
    if (storeData) {
      setStampImageUrl(storeData.stampImageUrl)
      setTextColor(storeData.textColor)
      setFontFamily(storeData.font)
    }
  }, [storeData])

  return (
    <Grid
      xs={4}
      key={props.gridKey}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: 95,
      }}
      ref={elementRef}
    >
      <ImageStamp
        index={props.index}
        stampImageUrl={stampImageUrl}
        textColor={textColor}
        fontFamily={fontFamily}
        handleFileChange={handleFileChange}
      />
    </Grid>
  )
}

export default Stamp
